<template>
  <div class="search_box">
    <div class="search_list flex">
      <div class="search_item" v-for="(item, index) in filed" :key="index">
        <!--select--->
        <div class="search_item_label">{{ item.label }}</div>
        <template v-if="item.type == 'select'">
          <el-select size="small" clearable filterable :multiple="item.multi" v-model="formData[item.value]"
            placeholder="請選擇">
            <el-option v-for="option in item.options" :key="option[item.options_value]"
              :label="option[item.options_label]" :value="option[item.options_value]"></el-option>
          </el-select>
        </template>
        <template v-if="item.type == 'date'">
          <el-date-picker size="small" v-model="formData[item.value]" type="date" value-format="yyyy-MM-dd"
            placeholder="Day" popper-class="picker-date"></el-date-picker>
        </template>
        <template v-if="item.type == 'radio'">
          <!-- {{item}} -->
          <el-radio-group v-model="formData[item.value]">
            <el-radio v-for="option in item.options" :label="option[item.options_value]" :key="option.id">{{
              option[item.options_label] }}</el-radio>
          </el-radio-group>
        </template>
      </div>
    </div>
    <div class="search_btn flex">
      <button class="btn_border_black" v-if="!searchStatus" @click="searchAction(formData)">
        <i class="el-icon-search"></i>搜尋
      </button>
      <button v-else class="btn_gray">
        <i class="el-icon-loading"></i>處理中
      </button>
    </div>
  </div>
</template>

<style lang="scss">
.search_box {
  background: #fff;
  padding: 13px 20px;
  border-radius: 10px;
  text-align: left;

  .search_list {
    flex-wrap: wrap;
  }

  .search_item {
    margin: 10px;

    .search_item_label {
      font-size: 14px;
      color: #999;
      margin-bottom: 5px;
    }
  }

  .search_btn {
    >button {
      width: 120px;
    }

    justify-content: flex-end;
  }
}

// 隱藏el-date-picker的header中, 年份的前後按鈕
.picker-date {
  .el-date-picker__header {
    button:nth-child(1) {
      display: none;
    }

    button:nth-child(5) {
      display: none;
    }
  }
}
</style>
<script>
export default {
  name: "search-box",
  props: {
    filed: Array,
    searchStatus: Boolean,
    searchAction: Function,
  },
  data() {
    return {
      formData: {},
    };
  },
  methods: {
    createFromData() {
      this.filed.forEach((el) => {
        //console.log(el);
        this.$set(this.formData, el, null);
      });
    },
  },
  created() {
    this.createFromData();
  },
};
</script>
